import React from "react";
import { Card, Col } from "react-bootstrap";
import SubscriptionsButton from "components/Subscriptions/SubscriptionsButton/SubscriptionsButton";
import { features } from "app/features";
import aiSumHover from "../PublicationCard/assets/icons/NaiRa_SUM_BUT_HOVER.svg";
import aiSumOn from "../PublicationCard/assets/icons/NaiRa_SUM_BUT_ON.svg";

import { Analysts, Title, PublicationDate, MinutesRead, Synopsis } from "../TileView/PublicationCardParts";
import { ShareButton } from "../ShareMenu/ShareButton";
import { useShowAiSummary } from "../../lib/hooks/useShowAiSummary";
import { auditAiSummaryClick } from "lib/analytics/auditEvents";
import "./featured.css";

export function FeaturedPubCard({ publication, styles, lang, imageUrl }) {
  const ImageStyles = {
    img: {
      maxHeight: "220px",
      backgroundRepeat: "no-repeat",
      backgroundAttachment: "scroll",
      backgroundPosition: "center",
      backgroundSize: "cover",
      margin: 0,
      backgroundImage: `url('${imageUrl}')`,
      height: "20vh",
    },
  };
  const openAISidebar = () => {
    auditAiSummaryClick(publication.id);
    window.dispatchEvent(new CustomEvent('open-naira-chat', { detail: { tab: 1, publicationId: publication.id } }));
  };
  const showAiSummary = useShowAiSummary(publication);

  return (
    <Col
      key={publication.id}
      lg={publication.lg || 4}
      md={publication.md || 6}
      sm={publication.sm || 6}
      xs={12}
      className="d-flex flex-column pb-2 px-2"
    >
      <Card lang="en" className="bg-white text-dark w-100 rounded-0 shadow card" style={ImageStyles.img} />
      <Card
        className={`${styles.card || ""} w-100 rounded-0 shadow card-body-grow`}
        style={styles.cardStyle}
        lang={lang}
      >
        <Card.Header
          className={`${styles.header || ""} border-bottom-0 featured-card-header`}
          style={showAiSummary ? { paddingRight: "122px", minHeight: "48px" } : undefined}>
          <Analysts lang={lang} {...publication} styles={styles} />
          {showAiSummary && (
            <button className="featured-ai-summary-btn" onClick={() => openAISidebar()}>
              <img src={aiSumHover} alt="AI Summary" className="featured-ai-icon-hover" />
              <img src={aiSumOn} alt="AI Summary" className="featured-ai-icon-on" />
            </button>
          )}
        </Card.Header>

        <Card.Body className={`${styles.body} py-0 publication-synopsis`}>
          <Card.Title className={`${styles.title || ""}`}>
            <Title {...publication} isFeaturedReport={true} />
          </Card.Title>
          <Synopsis {...publication} styles={styles} />
        </Card.Body>

        <Card.Footer className={`border-top-0 ${styles.footer || ""}`}>
          {publication?.language !== "ja" && <MinutesRead wordCount={publication?.instrumentation?.wordCount || 0} />}
          <PublicationDate {...publication} />
          <ShareButton publication={publication} />        
          {features.subscriptionButton && (
            <div className="featured-subscribe-row">
              <SubscriptionsButton publication={publication} isFromFeaturedCard />
            </div>
          )}
        </Card.Footer>
      </Card>
    </Col>
  );
}
